export type TransactionsHeaderSlot = "pending" | "bell" | "help";

/**
 * Right slot of TransactionsPage.
 * `inAppEnabled` is already resolved: a missing bind field counts as on.
 * With in-app off, the slot stays empty until the first list settles.
 */
export function resolveTransactionsHeader(input: {
  hasNovuSession: boolean;
  inAppEnabled: boolean;
  visibleCount: number;
  listReady: boolean;
  listFailed: boolean;
}): TransactionsHeaderSlot {
  if (!input.hasNovuSession) return "help";
  if (input.inAppEnabled || input.visibleCount > 0 || input.listFailed) {
    return "bell";
  }
  if (!input.listReady) return "pending";
  return "help";
}
